import React from 'react';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const AlertToast = props => {
  const { message, onClear, alertType = 'error' } = props;

  return (
    <Snackbar
      open={!!message}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      ClickAwayListenerProps={{ mouseEvent: false }}
      autoHideDuration={3 * 1000}
      disableWindowBlurListener={true}
      onClose={onClear}>
      <Alert onClose={onClear} severity={alertType}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AlertToast;
